import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateRegistroContableRequest } from '@models/registroContable/createRegistroContableRequest.model';
import { RegistroContableDto } from '@models/registroContable/registroContableDto.model';
import { UpdateRegistroContableRequest } from '@models/registroContable/updateRegistroContableRequest.model';
import { RegistroContableFilter } from '@models/registroContable/registroContableFilter.model';

@Injectable({
  providedIn: 'root'
})
export class RegistroContableService {

  constructor(private http:HttpClient) {
  }

  create(createRegistroContableRequest:CreateRegistroContableRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/RegistroContable/Create",createRegistroContableRequest);
  }

  update(updateRegistroContableRequest:UpdateRegistroContableRequest):Observable<any>
  {
    return  this.http.put<any>("/api/RegistroContable/Update",updateRegistroContableRequest);
  }

  getAll():Observable<RegistroContableDto[]> {
    return   this.http.get<RegistroContableDto[]>("/api/RegistroContable/GetAll");
  }

  getAllByIdExpediente(idExpediente:number):Observable<RegistroContableDto[]> {
    return   this.http.get<RegistroContableDto[]>("/api/RegistroContable/GetAllByIdExpediente?idExpediente="+idExpediente);
  }

  getAllByFilter(registroContableFilter: RegistroContableFilter):Observable<RegistroContableDto[]> {
    return   this.http.post<RegistroContableDto[]>("/api/RegistroContable/GetAllByFilter",registroContableFilter);
  }


  getById(id:number):Observable<RegistroContableDto>{
    return  this.http.get<RegistroContableDto>("/api/RegistroContable/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/RegistroContable/Delete?id=" + id);
    else
      return of(null)
  }

}
